import { render, staticRenderFns } from "./StudentSearch.vue?vue&type=template&id=5e98ef4e"
import script from "./StudentSearch.vue?vue&type=script&lang=js"
export * from "./StudentSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports